module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('ul', {
    staticClass: "list-hack p1111 card card-square ovf"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      staticClass: "p1111",
      staticStyle: {
        "width": "50%",
        "float": "left"
      }
    }, [_c('product', {
      attrs: {
        "name": item.name,
        "content": item.content,
        "image": item.image,
        "tip": item.tip,
        "limit": item.limit,
        "stock": item.stock,
        "amount": item.amount,
        "flag": item.flag,
        "ratio": "0.9"
      },
      on: {
        "on-click": function($event) {
          _vm.toast('点击详情')
        },
        "on-delete": function($event) {
          _vm.toast('商品归零')
        },
        "on-limit": function($event) {
          _vm.toast('达到上限')
        },
        "on-buy": function($event) {
          _vm.toast('购买')
        }
      }
    })], 1)
  })), _vm._v(" "), _c('ul', {
    staticClass: "list-hack p2222 m2000 card card-square ovf"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', [_c('product-single', {
      attrs: {
        "name": item.name,
        "content": item.content,
        "image": item.image,
        "tip": item.tip,
        "limit": item.limit,
        "stock": item.stock,
        "amount": item.amount,
        "flag": item.flag,
        "price": item.price,
        "ratio": "0.9"
      },
      on: {
        "on-click": function($event) {
          _vm.toast('点击详情')
        },
        "on-delete": function($event) {
          _vm.toast('商品归零')
        },
        "on-limit": function($event) {
          _vm.toast('达到上限')
        },
        "on-buy": function($event) {
          _vm.toast('购买')
        }
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-430daf3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/product/demo.vue
// module id = 244
// module chunks = 7